package com.arenaproplay.admin.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import com.arenaproplay.admin.navigation.Routes
import com.arenaproplay.admin.ui.theme.AppColors
import com.arenaproplay.admin.ui.theme.AppEffects
import com.arenaproplay.admin.ui.theme.toHexString
import com.arenaproplay.admin.ui.theme.bodyLMedium
import com.arenaproplay.admin.ui.theme.displayMedium
import com.arenaproplay.admin.ui.utils.sBorderRadius
import com.arenaproplay.admin.ui.utils.sPadding
import org.jetbrains.compose.web.css.*

@Page("/404")
@Composable
fun NotFoundPage() {
    val ctx = rememberPageContext()

    Box(
        Modifier
            .fillMaxSize()
            .backgroundColor(AppColors.Background),
        contentAlignment = Alignment.Center
    ) {
        Column(
            Modifier
                .sBorderRadius(16)
                .sPadding(48)
                .styleModifier {
                    property("background", "#${AppColors.Surface.toHexString()}")
                    property("border", "1px solid #${AppColors.Border.toHexString()}")
                    property("box-shadow", AppEffects.CardElevation)
                    property("text-align", "center")
                    property("animation", "arena-rise 300ms cubic-bezier(0.16, 1, 0.3, 1) both")
                },
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // Big "404" in Unbounded
            SpanText(
                "404",
                Modifier.styleModifier {
                    property("font-family", "'Unbounded', sans-serif")
                    property("font-size", "80px")
                    property("font-weight", "700")
                    property("color", "#${AppColors.Primary.toHexString()}")
                    property("letter-spacing", "-0.04em")
                    property("line-height", "1")
                }
            )

            Box(Modifier.height(16.px))

            SpanText(
                "Страница не найдена",
                Modifier.displayMedium().color(AppColors.Ink)
            )

            Box(Modifier.height(8.px))

            SpanText(
                "Возможно, ссылка устарела или была перемещена.",
                Modifier.bodyLMedium().color(AppColors.Muted).styleModifier {
                    property("max-width", "280px")
                    property("text-align", "center")
                    property("line-height", "1.5")
                }
            )

            Box(Modifier.height(32.px))

            // "На главную" button
            Box(
                Modifier
                    .sBorderRadius(10)
                    .sPadding(12, 24)
                    .cursor(Cursor.Pointer)
                    .styleModifier {
                        property("background", "#${AppColors.Primary.toHexString()}")
                        property("box-shadow", "0 2px 8px rgba(37,69,255,0.28)")
                        property("transition", "background 160ms ease, transform 160ms ease")
                    }
                    .onClick { ctx.router.navigateTo(Routes.DASHBOARD) }
            ) {
                SpanText(
                    "На главную",
                    Modifier.styleModifier {
                        property("font-family", "'Unbounded', sans-serif")
                        property("font-size", "14px")
                        property("font-weight", "600")
                        property("color", "#${AppColors.Surface.toHexString()}")
                        property("letter-spacing", "0.01em")
                    }
                )
            }
        }
    }
}
